import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingWhatsAppButton from "./FloatingWhatsAppButton";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <Navbar />

      {/* Page Content */}
      <main className="min-h-screen">
        <Outlet />
      </main>

      <Footer />
      
      {/* Floating WhatsApp Button */}
      <FloatingWhatsAppButton />
    </>
  );
};

export default Layout;
